/** Translate navigation only. A legacy semantic page ID is not a native page number. */
export function legacyReadingHref(bookId: string, search: string, find = false): string {
  const source = new URLSearchParams(search);
  const next = new URLSearchParams({ book: bookId });
  const page = source.get("page");
  if (page === "cover" || page === "0") next.set("page", "0");
  else if (page && /^\d{1,3}$/u.test(page)) next.set("page", String(Number(page)));
  else if (page) {
    next.set("legacyPage", "unmapped");
    next.set("panel", "contents");
  }
  const tool = source.get("panel");
  if (find || tool === "find") next.set("panel", "find");
  else if (tool === "contents") next.set("panel", "contents");
  const edition = source.get("edition");
  if (edition && /^[A-Za-z0-9:_-]{1,200}$/u.test(edition)) next.set("edition", edition);
  return `/app?${next}`;
}
